if (!customElements.get('tm-card-swatches')) {
  customElements.define(
    'tm-card-swatches',
    class TmCardSwatches extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const button = event.target.closest('[data-variant-id]');
        if (!button || !this.contains(button) || button.disabled) return;

        event.preventDefault();
        event.stopPropagation();
        this.apply(button);
      }

      apply(button) {
        const card = this.closest('.tm-product-card, .product-row-4-card');
        if (!card) return;

        this.querySelectorAll('[data-variant-id]').forEach((el) => {
          if (el.disabled) return;
          el.setAttribute('aria-pressed', el === button ? 'true' : 'false');
        });

        const mediaUrl = button.getAttribute('data-media-url');
        const mediaSrcset = button.getAttribute('data-media-srcset');
        const mediaAlt = button.getAttribute('data-media-alt');

        if (mediaUrl) {
          const img = this.findMainImage(card);
          if (img) {
            img.src = mediaUrl;
            if (mediaSrcset) img.srcset = mediaSrcset;
            if (mediaAlt) img.alt = mediaAlt;
          }
          card.classList.add('is-swatch-active');
        }

        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        card.querySelectorAll('a[href]').forEach((anchor) => {
          const href = anchor.getAttribute('href');
          if (!href || href === '#') return;
          try {
            const url = new URL(anchor.href, window.location.origin);
            url.searchParams.set('variant', variantId);
            anchor.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
          } catch (error) {
            // ignore malformed href
          }
        });

        const variantInput = card.querySelector('input.product-variant-id');
        if (variantInput) variantInput.value = variantId;
      }

      findMainImage(card) {
        return (
          card.querySelector('.tm-product-card__image:not(.tm-product-card__image--secondary)') ||
          card.querySelector('.product-row-4-card__img-main')
        );
      }
    }
  );
}
